const invoicesubmissionmanagement = r => require.ensure([], () => r(require('../../views/controloverinvoices/invoicesubmissionmanagement/invoicesubmissionmanagement.vue')), 'invoicesubmissionmanagement')
const SMSProviderRecord = r => require.ensure([], () => r(require('../../views/controloverinvoices/SMSProviderRecord/SMSProviderRecord.vue')), 'SMSProviderRecord')
const SaleBillRepeatInfo = r => require.ensure([], () => r(require('../../views/controloverinvoices/SaleBillRepeatInfo/SaleBillRepeatInfo.vue')), 'SaleBillRepeatInfo')

const controloverinoicesChildrenRouter = [
    {
        path: '/SMS/SaleBill',
        name: 'invoicesubmissionmanagement',
        component: invoicesubmissionmanagement,
        meta: {
            typePage: 2
        },
    },
    {
        path: '/SMS/ProviderRecord',
        name: 'SMSProviderRecord',
        component: SMSProviderRecord,
        meta: {
            typePage: 2
        },
    },
    {
        path: '/SMS/SaleBillRepeatInfo',
        name: 'SaleBillRepeatInfo',
        component: SaleBillRepeatInfo,
        meta: {
            typePage: 2
        },
    }
];
export default controloverinoicesChildrenRouter
